import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useAuthState } from '../../../../../Helper/Context';


export default function OfficialMasterCardData(props) {

    const { Countdata, ActiveMasterCard, handleActiveMasterCardClick, ActiveButton, handleButtonClick } = props

    const userDetails = useAuthState();
    const { UserID, token, RoleID } = userDetails

    const { t } = useTranslation()

    const [searchParams] = useSearchParams()
    let Lang = searchParams.get("Lang")
    const navigate = useNavigate()



    const data = [
        {
            'title': t('Dashboard.Pcmc_Assets.Garden_Master'),
            'cardName': 'py-2 gray2 cursor ',
            'border': 'green_border',
            'count': Countdata.GardenTotalCount ? Countdata.GardenTotalCount : '0',
            'navigate': '1',
            'imgPath': "./assets/img/pine-tree.png",
            'color': ActiveMasterCard == '1' ? " fw-bold px-2 activebuttonofficials text-white card-footer px-3 " : "border-dark bg-whites card-footer px-3",
            'countcolour': ActiveMasterCard == '1' ? " text-white " : "text-dark",
        },
        {
            'title': t('Dashboard.Pcmc_Assets.Road_Divider'),
            'cardName': 'py-2 blue cursor ',
            'border': 'blue_border',
            'count': Countdata.RoadDividerTotalCount ? Countdata.RoadDividerTotalCount : '0',
            'navigate': '2',
            'imgPath': "./assets/img/diversion.png",
            'color': ActiveMasterCard == '2' ? " fw-bold px-2 activebuttonofficials text-white card-footer px-3 " : "border-dark bg-whites card-footer px-3",
            'countcolour': ActiveMasterCard == '2' ? " text-white " : "text-dark",

        },

    ]

    const data12 = [
        {
            'title': t('Dashboard.Pcmc_Assets.Garden_Master'),
            'cardName': 'py-2 gray2 cursor ',
            'border': 'green_border',
            'count': Countdata.GardenTotalCount ? Countdata.GardenTotalCount : '0',
            'navigate': '1',
            'imgPath': "./assets/img/pine-tree.png",
            'color': ActiveMasterCard == '1' ? " fw-bold px-2 activebuttonofficials text-white card-footer px-3 " : "border-dark bg-whites card-footer px-3",
            'countcolour': ActiveMasterCard == '1' ? " text-white " : "text-dark",
        }
    ]

    const Datta = ( RoleID == 12 || RoleID == 17 || RoleID == 20 ||RoleID == 16 || RoleID == 30 || RoleID == 31 ) ? data12 : data

    return (
        <div>


            <div className='row mast_row gar_new_mas px-2 m-0'>
                {
                    Datta && Datta.length > 0 && Datta.map((i, j) => {

                        return (
                            <div class=" col-sm-6 col-lg-2 mastercard px-1 mb-0">
                                <div className="card py-0 shadow mb-0 "
                                    onClick={() => (i.navigate == 1 || i.navigate == 2) ? handleActiveMasterCardClick(i.navigate) : ''}
                                    style={{
                                        cursor: i.navigate == 1 || i.navigate == 2 ? 'pointer' : 'not-allowed'
                                    }}
                                >
                                    <div className={i.color}>
                                        <div className="bg_gray row align-items-center">
                                            <div className="col-7">
                                                <p className="mb-0" style={{ whiteSpace: "nowrap", fontSize: '15px' }}><b>{i.title}</b></p>
                                            </div>
                                            <div className="col-5 text-end">
                                                <h4 className={i.countcolour}>{i.count}</h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }

                <div className={( RoleID == 12 || RoleID == 17 || RoleID == 20 ||RoleID == 16 || RoleID == 30 || RoleID == 31 ) ? "col-12 col-lg-10 d-flex align-items-center justify-content-end float-end" : "col-12 col-lg-8 d-flex align-items-center justify-content-end float-end"}>
                    <div className="btn-group  float-end" role="group" aria-label="Basic outlined example" style={{ border: '1px solid #cf4141', borderRadius: '5px', }}>
                        <button
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => handleButtonClick('उद्यान दैनंदिन कामे')}
                            className={ActiveButton == 'उद्यान दैनंदिन कामे' ? "btn fw-bold px-2 activebutton2 text-white d-flex border-ends2" : "text-black fw-bold btn px-1 d-flex hovernone border-ends2"}
                        > {t('Dashboard.Titles.Garden_Daily_Work')}</button>

                        <button
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => handleButtonClick('प्रशासनाने वाटप केलेली कामे')}
                            className={ActiveButton == 'प्रशासनाने वाटप केलेली कामे' ? "btn px-2 fw-bold activebutton2 text-white d-flex border-ends2" : "text-black fw-bold btn px-1 d-flex hovernone border-ends2"}
                            type="button">{t('Dashboard.Titles.Work_Assigned_by_Officials')}</button>
                        <button

                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => handleButtonClick('ठेकेदारनिहाय कामाची प्रगती')}
                            className={ActiveButton == 'ठेकेदारनिहाय कामाची प्रगती' ? "btn px-2 fw-bold activebutton2 text-white d-flex border-ends2" : "text-black fw-bold btn px-1 d-flex hovernone border-ends2"}
                            type="button">{t('Dashboard.Titles.Work_Progress_By_Contractor')}</button>

                        <button
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => handleButtonClick('पुन्हा वाटप केलेल्या कामाची प्रगती')}
                            className={ActiveButton == 'पुन्हा वाटप केलेल्या कामाची प्रगती' ? "btn px-2 fw-bold activebutton2 text-white d-flex " : "text-black fw-bold btn px-1 d-flex hovernone "}
                            type="button">{t('Dashboard.Titles.Work_Reopen_Progress_By_Contractor')}</button>
                    </div>
                </div>
            </div>


        </div>



    )

}

